import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Кіпоренко Галина',
  role: 'Голова колегії суддів',
  email: 'gala.kepar@gmail.com'
}, {
  name: 'Бондарев Микола',
  role: 'Член колегії суддів',
  email: 'luckynickybon@gmail.com'
}, {
  name: 'Ткаченко Євгенія',
  role: 'Членкиня колегії суддів',
  email: 'Alpirbis8848@gmail.com'
}];
export function JudgesBoard() {
  return <FederationMembersPage title="Колегія суддів" subtitle="Колегія суддів скельного комітету ФАіСУ" members={members} data-id="element-563" />;
}